<template>
  <div
    v-if="items.length || isApprovalPending"
    class="bg-warning-20 q-pa-md q-mt-sm rounded-borders"
  >
    <div class="row items-center q-gutter-sm">
      <WarningIcon class="text-warning-70 icon" />
      <div class="text-sm text-weight-demibold">
        {{
          isApprovalPending
            ? "There is already an invoice pending for approval with overlapped items."
            : "Overselling identified"
        }}
      </div>
    </div>

    <div
      v-if="!isApprovalPending && items.length"
    >
      <ul class="q-mt-sm q-pl-md">
        <li v-for="(item, index) in items" :key="index">
          {{ item.name }} | Oversold Qty: {{ item.overBy }}
        </li>
      </ul>

      <div class="q-mt-md">
        Click on “<strong>{{
          isSendForApprovalButtonVisible ? "Send for Approval" : "Submit"
        }}</strong
        >” button to
        {{
          isSendForApprovalButtonVisible
            ? "get approval on this invoice request"
            : "check for overselling items"
        }}
      </div>
    </div>
  </div>
</template>

<script setup>
import WarningIcon from "assets/icons/exclamation-round.svg";

defineProps({
  items: {
    type: Array,
    required: true,
  },
  isApprovalPending: {
    type: Boolean,
  },
  isSendForApprovalButtonVisible: {
    type: Boolean,
  },
});
</script>
